module.exports = __webpack_public_path__ + "static/media/cosmetics4.b8af8677.png";